import { challenges } from "./challenges"
import { flashcards } from "./flashcards"
import { login } from "./login"
import { payments } from "./payments"
import { signUp } from "./sign-up"
import { global } from "./global"
import { diagnoses } from "./diagnoses"
const mixpanelClient = {
  global,
  signUp,
  login,
  challenges,
  flashcards,
  payments,
  diagnoses,
}

export default mixpanelClient
